<template>
	<div class="flex justify-center items-center bg-gray-200 h-screen">
		<div class="bg-white shadow-lg rounded p-4">
			<h1 class="font-bold text-2xl text-center w-full">Octiq</h1>
			<div class="flex flex-col space-y-4 my-5">
				<div class="flex flex-col">
					<label>Email</label>
					<input v-model="model.email" v-bind:class="{ invalid: validation.email }" class="border-2 border-blue-300 hover:border-blue-500 rounded py-2 px-2" type="text" placeholder="john@example.org" />
				</div>
				<div class="flex flex-col">
					<label>Password</label>
					<input v-model="model.password" v-bind:class="{ invalid: validation.password }" class="border-2 border-blue-300 hover:border-blue-500 rounded py-2 px-2" type="password" placeholder="Password" />
				</div>
			</div>
			<button v-on:click="login" class="w-80 bg-blue-500 rounded p-2 text-white">Login</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "Login",

	data: () => ({
		model: {
			email: null,
			password: null
		},
		validation: {
			email: null,
			password: null
		}
	}),

	methods: {

		login() {

            /**
             * We need to reset all the error fields before request
             * login again.
             */
            this.validation.email = false
            this.validation.password = false

			this.$store.dispatch("user/login", {
                email: this.model.email,
                password: this.model.password,
			}).then(() => {
                this.$router.push("/orders")
            }).catch(Response => {
                Response.error.fields.forEach(field => {
                    this.validation[field.field] = true
                })
            })

		}

	}
}
</script>

<style scoped>
label {
	font-family: "Open Sans";
	font-size: 12px;
	font-weight: 600;
	color: #848484;
}

input.invalid {
    border-color: red !important;
}

input:focus-visible {
	outline: none !important;
}
</style>
